// Components==============
import { ProcessGroups } from 'hooks/useProcessGroups';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import { useContext } from 'react';
// =========================

export const useConditionalValues = ({
  reflectionProcessGroups,
  reflectionProject,
}: {
  reflectionProcessGroups?: ProcessGroups;
  reflectionProject?: ProjectProjectEntity;
}) => {
  const { processGroups } = useContext(ProjectDetailsContext);
  const { project } = useContext(ProjectDetailsContext);

  return {
    conditionalProcessGroups: reflectionProcessGroups || processGroups,
    conditionalProject: reflectionProject || project,
  };
};
